import { create } from '@thoughtspot/logger';
import { processLegacyDataToSDKQueryData } from '../../../utils/chart-model-adaptor.util';
import { mapSDKQueryToDataQueryInput } from '../../../utils/data-query.util';
import { OtelOp } from '../../../utils/otel-operations';
import { childContext, startSpan } from '../../../utils/tracer';
import { validateGetDataForQueryEventPayloadObject } from './util';
const logger = create('ts-to-chart > event-callbacks > get-data-query');
const validateGetDataForQueryEventPayload = (eventData) => {
    try {
        validateGetDataForQueryEventPayloadObject(eventData.payload);
    }
    catch (err) {
        logger.warn(err);
        return {
            isValid: false,
            errors: [err.toString()],
        };
    }
    return {
        isValid: true,
    };
};
const getGetDataForQueryEventProcessor = (props) => {
    return {
        validateEventPayload: (eventData) => {
            return validateGetDataForQueryEventPayload(eventData);
        },
        executeEvent: async (eventData) => {
            const { otelContext, otelEnabled = false } = props;
            const queries = eventData?.payload?.queries;
            const dataQueryInput = mapSDKQueryToDataQueryInput(queries);
            const dataFetchSpan = startSpan(OtelOp.NETWORK_DATA_FETCH, otelContext, otelEnabled, { 'data_fetch.source': 'chart_event' });
            const dataFetchCtx = childContext(otelContext, dataFetchSpan);
            try {
                const res = await props.getAnswerDataByQuery(dataQueryInput, dataFetchCtx);
                dataFetchSpan.end();
                const parsedData = processLegacyDataToSDKQueryData(res);
                return Promise.resolve(parsedData);
            }
            catch (err) {
                dataFetchSpan.setStatus({ code: 2 });
                dataFetchSpan.end();
                throw err;
            }
        },
    };
};
export { getGetDataForQueryEventProcessor };
//# sourceMappingURL=index.js.map